import { render, staticRenderFns } from "./DosyaTuruPicker.vue?vue&type=template&id=83d7ae1a"
import script from "./DosyaTuruPicker.vue?vue&type=script&lang=ts"
export * from "./DosyaTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports